import React from 'react';

type LegalTemplateProps = {
  children: React.ReactNode;
};

/**
 * Long-form legal reading: left-aligned, top-anchored, and dressed in whatever
 * brand the route carries — which for these documents is Midnight Swim.
 */
const LegalTemplate: React.FC<LegalTemplateProps> = ({ children }) => {
  return <section className="detail-page detail-page--legal">{children}</section>;
};

export default LegalTemplate;
